var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 100,
    viewBox: "0 0 89 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02139 90.0345L0 0.000488281H88.1867L80.1653 89.9859L44.0204 100",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.093 92.3445V7.39062H80.1407L73.2617 84.2015",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3831 18.4014H44.0933V29.4369H28.4881L29.509 40.7397H44.0933V51.7509H19.3972L16.3831 18.4014ZM19.8833 57.293H30.9674L31.7452 66.1165L44.0933 69.4223V80.9439L21.439 74.624",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7058 18.4014H44.0442V29.4369H70.6849L71.7058 18.4014ZM69.6883 40.7397H44.0442V51.7752H57.6562L56.368 66.1165L44.0442 69.4223V80.8953L66.6499 74.624",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.61b29980ba0acc4465c254972f1abcc2.svg";
export { ForwardRef as ReactComponent };